import { HandlersCollection } from '@tblabs/truffle';
import { PictureForWebClient } from '../../Models/PictureForWebClient';
import { BlobPicture } from "../../Models/BlobPicture";
import { PictureConverter } from "../../Models/PictureConverter";
import { OutputSetCommand } from '../../Models/OutputSetCommand';
import { InputState } from '../../Models/SensorState';
import { Server } from '../Server';
import { ConnectionStatusEvent } from '../ConnectionStatusEvent';
import { ICamera } from './ICamera';
import { DeviceConfigForWatcher, DeviceSettingsForWatcher } from '../../Models/DeviceConfig';
import { DeviceConnectionStatus } from "../../Models/DeviceConnectionStatus";
import { DeviceStateForWatcher } from './DeviceStateForWatcher';
import { IoState } from './IoState';


export class Camera implements ICamera
{
    public DeviceId = "";
    public IsConnected = false;
    private deviceConfig: DeviceConfigForWatcher;
    public IoState: IoState = { InputsState: {}, InputsMalfunction: [], OutputsState: {} };
    public Malfunctions: string[] = [];
    public OnConnectionChange = new HandlersCollection<(event: ConnectionStatusEvent) => void>();
    public OnConfigReceived = new HandlersCollection<(config: DeviceConfigForWatcher) => void>();
    public OnNewPicture = new HandlersCollection<(picture: BlobPicture) => void>();
    public OnMalfunction = new HandlersCollection<(reason: string) => void>();
    public OnInputMalfunction = new HandlersCollection<(inputName: string) => void>();
    public OnIoStateChange = new HandlersCollection<(ioState: IoState) => void>();
    public OnInputChange = new HandlersCollection<(state: InputState) => void>();

    public get Config(): DeviceConfigForWatcher
    {
        return this.deviceConfig;
    }

    private Log(...msg)
    {
        // console.log('[Camera]', ...msg);
    }

    constructor(private _server: Server)
    { }

    private SetConnectionStatus(status: DeviceConnectionStatus): void
    {
        this.IsConnected = status === DeviceConnectionStatus.Connected;
        const event = new ConnectionStatusEvent(this.IsConnected, status);

        this.OnConnectionChange.Call(event);
    }

    public Init(): void
    {
        this._server.Socket
            .on('device:connection-status', (status: DeviceConnectionStatus) =>
            {
                this.SetConnectionStatus(status);
            })
            .on('device:config', (config: DeviceConfigForWatcher) =>
            {
                // console.log('device:config', config);
                this.deviceConfig = { ...this.deviceConfig, ...config };
                // console.log('device:config', this.deviceConfig); // TODO: sprawdzić czy to przylatuje po zmianie ustawień

                this.OnConfigReceived.Call(this.deviceConfig);
            })
            .on('device:picture', (pictureFromServer: PictureForWebClient) =>
            {
                if (this.deviceConfig?.Halt)
                {
                    this.Log(`Camera halted but still receiving (#${pictureFromServer.IndexFromDevice})`);
                    return;
                }

                const blobPicture = PictureConverter.Convert(pictureFromServer);

                this.Log(`Received picture #${blobPicture.IndexFromDevice}, ${blobPicture.Image.size} bytes`);
                this.OnNewPicture.Call(blobPicture);
            })
            .on('device:input-state', (state: InputState) =>
            {
                this.OnInputChange.Call(state);
            })
            .on('device:io-state', (ioState: IoState) =>
            {
                // console.log('device:io-state', ioState);
                this.IoState = ioState;
                this.OnIoStateChange.Call(ioState);
            })
            .on('device:state', (state: DeviceStateForWatcher) =>
            {
                // console.log('device:state', state);
                this.IoState = state.Io;
                this.Malfunctions = state.Malfunctions;

                this.OnIoStateChange.Call(this.IoState);

                this.IoState?.InputsMalfunction?.forEach(inputName =>
                    this.OnInputMalfunction.Call(inputName));

                // this.Malfunctions.forEach(malfunction =>
                //     this.OnMalfunction.Call(malfunction));
                if (this.Malfunctions.length > 0)
                    this.OnMalfunction.Call(this.Malfunctions.join(', '));
            })
            .on('device:malfunction', (reason: string) =>
            {
                // console.log('device:malfunction', reason);
                this.OnMalfunction.Call(reason);
            })
            .on('device:input-malfunction', (inputName: string) =>
            {
                // console.log('device:input-malfunction', inputName);
                if (!this.IoState.InputsMalfunction.includes(inputName))
                    this.IoState.InputsMalfunction.push(inputName);

                this.OnInputMalfunction.Call(inputName);
            });
    }

    public Halt(): void
    {
        if (!this.IsHalted)
            this.UpdateSettings({ Halt: true } as DeviceSettingsForWatcher);
    }

    public Unhalt(): void
    {
        // console.log('Unhalt', this.IsHalted);
        // if (this.IsHalted) // TODO: dlaczego to jest źle ustawione????????????????????????
        this.UpdateSettings({ Halt: false } as DeviceSettingsForWatcher);
    }

    public get IsHalted(): boolean
    {
        return this.deviceConfig?.Halt ?? false;
    }

    public UpdateSettings(settings: DeviceSettingsForWatcher): void
    {
        this.Log(`Updating settings to`, settings);

        this.ToServer('settings', settings);
    }

    public CheckCameraConnection(): void
    {
        this.ToServer('check-camera-connection', this.DeviceId);
    }

    private ToServer(cmd: string, ...args: any[]): void
    {
        this._server.Socket?.emit(cmd, ...args);
    }

    private outputCache: Record<string, number> = {};
    public SetOutput(name: string, state: number): void
    {
        if (this.outputCache[name] === state)
            return;

        this.outputCache[name] = state;

        const command = new OutputSetCommand(name, state);

        this.Log(`Sending output-set command:`, command);

        this.ToServer('output-set', command);
    }

    public Destroy(): void
    { }
}
